<template>
  <div class="partner-tab-bulk-actions">
    <BittsDropdown
      :options="actionOptions"
      placement="bottomRight"
      @selection="handleSelection"
    >
      <template #prompt>
        <BittsButton
          data-testid="by-partners__actions-button"
          text="Actions"
          type="neutral"
          variant="outline"
          size="small"
          :right-icon="['fak', 'chevron-down']"
        />
      </template>
    </BittsDropdown>
  </div>
</template>

<script setup lang="ts">
import { BittsButton, BittsDropdown, type BittsIcon } from '@crossbeam/bitts';

import { computed } from 'vue';

import { BULK_REMOVE_PARTNERS_LIMIT } from '@/constants/partners';

const { selectedCount } = defineProps<{ selectedCount: number }>();

const emit = defineEmits<{
  'edit-tags': [];
  remove: [];
}>();

const NO_SELECTION_TOOLTIP = 'Select at least one partner first';
const REMOVE_LIMIT_TOOLTIP = `You can remove up to ${BULK_REMOVE_PARTNERS_LIMIT} partners at a time`;

const ACTIONS = [
  {
    value: 'edit_tags',
    display: 'Edit tags',
    iconType: ['fak', 'tag'] as BittsIcon,
  },
  {
    value: 'remove',
    display: 'Remove partners',
    iconType: ['fak', 'delete'] as BittsIcon,
    danger: true,
  },
];

const isOverRemoveLimit = computed(
  () => selectedCount > BULK_REMOVE_PARTNERS_LIMIT,
);

function disabledTooltip(value: string) {
  if (!selectedCount) return NO_SELECTION_TOOLTIP;
  if (value === 'remove' && isOverRemoveLimit.value)
    return REMOVE_LIMIT_TOOLTIP;
  return undefined;
}

const actionOptions = computed(() =>
  ACTIONS.map((action) => {
    const tooltip = disabledTooltip(action.value);
    return { ...action, disabled: !!tooltip, tooltip };
  }),
);

function handleSelection(option: { value: string; disabled?: boolean }) {
  if (option.disabled) return;
  if (option.value === 'edit_tags') emit('edit-tags');
  else if (option.value === 'remove') emit('remove');
}
</script>
